import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from '@hungryroot/component-error-boundary';
import {
  Breadcrumb,
  FunnelHeader,
  useFunnelRedirects,
} from '@hungryroot/funnel';
import { SignUp, useSignupSuccess } from '@hungryroot/page-signup';
import { queryClientOptions } from '@hungryroot/rest';
import { Utm } from '@hungryroot/segment';
import { renderApp } from '../../frontend/react/src/utils/utils';
import './signup.module.css';

const elm = document.createElement('div');
elm.id = 'signup-page-react-root';
document.body.appendChild(elm);
const container = document.getElementById('container');
const parent = container?.parentNode;
if (container !== null) {
  parent?.removeChild(container);
}

function SignupScreen() {
  // A visitor can land here having skipped the quiz entirely, so this page must
  // not enroll them in quiz-content experiments (220) — they could never
  // have experienced those treatments. Safe to suppress: this page reads only
  // `afterSignup` and `afterQuiz`, neither of which depends on an experiment.
  // Exp 234 is intentionally not suppressed. See WEB-7482.
  const redirects = useFunnelRedirects({ suppressEnrollment: [220] });

  const onSignupSuccessV2 = useSignupSuccess();

  if (redirects === null) {
    return null;
  }

  const queryParams = new URLSearchParams(window.location.search);
  const nextRedirect = queryParams.get('next') ?? undefined;

  return (
    <>
      <Utm search={window.location.search} />
      <SignUp
        nonCheckedOutSignupSuccessUrl={nextRedirect || redirects.afterSignup}
        onNavigate={(route) => {
          window.location.href = route;
        }}
        onSignupSuccess={({ data, provider }) => {
          const { id: userId } = data;

          onSignupSuccessV2.onSuccess(
            userId,
            nextRedirect || redirects.afterSignup,
            data,
            provider,
            redirects.afterQuiz
            // don't need to pass the firstBoxAdhereVariant here because the onSignupSuccess hook
            // uses the useServerPersist hook which already uses the experiment hook
          );
        }}
        header={
          <FunnelHeader>
            <Breadcrumb selected="Claim Offer" />
          </FunnelHeader>
        }
      />
    </>
  );
}

renderApp(
  <ErrorBoundary>
    <QueryClientProvider client={new QueryClient(queryClientOptions)}>
      <SignupScreen />
    </QueryClientProvider>
  </ErrorBoundary>,
  'signup-page-react-root'
);
